import React from "react";
import classNames from "classnames";

const SwKpiGroup = ({ children, className = "" }) => {
  return (
    <div className={classNames("SwKpiBox-Container", className)}>
      {children}
    </div>
  );
};

export default SwKpiGroup;
